import { create } from "zustand";

const useFormStore = create((set) => ({
  formData: {},
  setFormData: (key, value) =>
    set((state) => ({
      formData: {
        ...state.formData,
        [key]: value,
      },
    })),
  clearFormData: () =>
    set(() => ({
      formData: {},
    })),
}));

export default useFormStore;
